// extracted by mini-css-extract-plugin
module.exports = {"card":"w_V","imageContainer":"w_cd","image":"w_cv","arrowLink":"w_b9","content":"w_s","title":"w_f","description":"w_g"};